import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from 'src/app/state/store';

const getPromoSignUp = (state: RootState) => state?.promoOnboarding;
export const getPromoSignUpZipCode = createSelector(getPromoSignUp, state => state?.zipCode);
export const getCurrentPromoOnboardingStepIndex = createSelector(
  getPromoSignUp,
  state => state?.currentOnboardingStepIndex
);
export const getPromoOnboardingSteps = createSelector(getPromoSignUp, state => state?.onboardingSteps);
export const getPromoCodeOnboarding = createSelector(getPromoSignUp, state => state?.promoCode);
export const getPromoOnboardingHasExistingAccount = createSelector(getPromoSignUp, state => state?.hasExistingAccount);
export const getPromoOnboardingTransfers = createSelector(getPromoSignUp, state => state?.transferMedications);
export const getPromoOnboardingRedirect = createSelector(getPromoSignUp, state => state?.postOnboardingRedirect);
export const getPromoOnboardingDefaultZipCode = createSelector(getPromoSignUp, state => state?.defaultZipCode);
export const getPromoOnboardingEmployeeType = createSelector(getPromoSignUp, state => state?.employeeDescription);
